export default __webpack_public_path__ + "static/media/341-tile.fc8e7421.svg";